<template>

</template>
<script>


export default {
  name: 'home',
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue